import React, { FC, useCallback, useEffect } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { BlueButton, NavButton } from 'components/Button'
import { MainHeadline } from 'components/Typography'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCoupons, getExpiredDate } from 'reducks/coupon/operations'
import { State } from 'index'
import { getCoupons } from 'reducks/coupon/selectors'
import { CouponType } from 'types/coupon'
import { isAfter, isBefore } from 'date-fns'
import { CouponAccordion } from 'components/Accordion'
import { useQueryAllStores } from 'hooks/store'
import { push } from 'connected-react-router'

const CouponListTemplate: FC = () => {
  const dispatch = useDispatch()
  const coupons: CouponType[] = useSelector((state: State) => getCoupons(state))
  const goToCouponCreatePage = useCallback(() => dispatch(push('/admin/coupon/create')), [dispatch])
  useEffect(() => {
    dispatch(fetchCoupons())
  }, [])
  const stores = useQueryAllStores()
  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'利用可能なクーポン'} />
      <Spacer size={20} />
      {coupons
        .filter(
          (coupon) =>
            coupon.status === 'public' &&
            // 有効期限無しのクーポンを含める
            ((!coupon.expires_at && !coupon.expires_maxage) ||
              isBefore(new Date(), getExpiredDate(coupon.expires_at || undefined, coupon.expires_maxage || 0)))
        )
        .map((coupon) => {
          return (
            <React.Fragment key={coupon.coupon_id}>
              <CouponAccordion coupon={coupon} isExpired={false} stores={stores} />
              <Spacer size={20} />
            </React.Fragment>
          )
        })}
      <MainHeadline headline={'期限切れクーポン'} />
      <Spacer size={20} />
      {coupons
        .filter(
          (coupon) =>
            coupon.status !== 'public' ||
            // 有効期限無しのクーポンを除外する
            ((coupon.expires_at || coupon.expires_maxage) &&
              isAfter(new Date(), getExpiredDate(coupon.expires_at || undefined, coupon.expires_maxage || 0)))
        )
        .map((coupon) => {
          return (
            <React.Fragment key={coupon.coupon_id}>
              <CouponAccordion coupon={coupon} isExpired={true} stores={stores} />
              <Spacer size={20} />
            </React.Fragment>
          )
        })}
      <BlueButton
        endIconPath={'/icon/white/arrow_next_small.svg'}
        label={'クーポンを登録する'}
        onClick={goToCouponCreatePage}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={20} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/admin/shops'} />
      <Spacer size={72} />
    </div>
  )
}

export default CouponListTemplate
